<template>
    <el-dialog
        title="编辑节点"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form
            label-position="right"
            label-width="100px"
            :model="enterNode"
            :rules="rules"
            ref="infoRef">
            <el-form-item label="节点名称:" prop="name">
                <el-input v-model="enterNode.name" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item label="节点链接:" prop="href">
                <el-input v-model="enterNode.href" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="节点内容:">
                <el-input
                    type="textarea"
                    rows="5"
                    maxlength="250"
                    show-word-limit="show-word-limit"
                    v-model="enterNode.content"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="reset">重 置</el-button>
            <el-button type="primary" @click="updateNode">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "addNode",
        data() {
            return {
                dialogVisible: false,
                enterNode: {
                    id: "",
                    name: "",
                    layer: "",
                    note: "",
                    content: "",
                    href: ""
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: '请输入节点名称',
                            trigger: 'blur'
                        }
                    ],
                    href: [
                        {
                            message: "请检查链接格式",
                            pattern: '[http://|ftp://|https://|wmw]?[^\u4e00-\u9fa5\s]*?\.[com|net|cn|me|tw|fr][^' +
                                '\u4e00-\u9fa5\s]*'
                        }
                    ]
                }
            }
        },
        created() {},
        methods: {
            getNodeInfo(res) {
                this.dialogVisible = true
                this.enterNode = res
            },
            handleClose() {
                this.dialogVisible = false
            },
            updateNode() {
                // 修改节点
                this
                    .$refs['infoRef']
                    .validate((valid) => {
                        if (valid) {
                            this
                                .$http
                                .post("/node/updateNode", {
                                    _id: this.enterNode.id,
                                    name: this.enterNode.name,
                                    content: this.enterNode.content,
                                    href: this.enterNode.href
                                })
                                .then((res) => {
                                    this.$emit("msg", "updateNode")
                                    this.dialogVisible = false
                                })
                        } else {
                            this
                                .$message
                                .error("请检查表单信息")
                            return false
                        }
                    })
            },
            reset() {
                this
                    .$refs['infoRef']
                    .resetFields();
                this.enterNode.name = ""
                this.enterNode.href = ""
                this.enterNode.content = ""
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/subComponents/updateNode.vue